import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { UserDetail } from 'types/api'

export const clientsQueryKey = ['clients']

export function useClientDetail(id?: string) {
  async function getClient() {
    const response = await apiClient.get<UserDetail>(SNA_PREFIX + `users/${id}`)

    return response.data
  }

  return useQuery({
    queryFn: getClient,
    queryKey: [...clientsQueryKey, id],
    enabled: !!id
  })
}
